import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/candidates/CandidateLayout.tsx");
